/** Shared visual language for menus and form choice popups. */
export const choicePopupClassName = [
  "z-50 min-w-52 max-w-[calc(100vw-1rem)] max-h-[var(--available-height)] overflow-y-auto overscroll-contain [overflow-wrap:anywhere] origin-[var(--transform-origin)] rounded-panel",
  "bg-elevated p-1 shadow-popup outline-none",
  "transition-[opacity,transform,scale] duration-100 motion-reduce:transition-none",
  "data-starting-style:scale-95 data-starting-style:opacity-0",
  "data-ending-style:scale-95 data-ending-style:opacity-0",
].join(" ");
export const choiceRowClassName = [
  "flex min-h-11 cursor-default select-none items-center gap-2 rounded-[5px] px-2 py-1.5 sm:pointer-fine:min-h-8 pointer-coarse:min-h-11 [[data-density=comfortable]_&]:min-h-11",
  "text-[13px] text-fg outline-none data-highlighted:bg-hover",
  "data-disabled:pointer-events-none data-disabled:opacity-40",
].join(" ");
export const choiceItemClassName = `${choiceRowClassName} [&_svg]:shrink-0 [&_svg]:text-fg-subtle`;
export const choiceLabelClassName =
  "px-2 pb-1 pt-1.5 text-2xs font-semibold uppercase tracking-[0.05em] text-fg-subtle";
